import { render, staticRenderFns } from "./ServicesAndIncoterms.vue?vue&type=template&id=ca1f77f4&scoped=true"
import script from "./ServicesAndIncoterms.vue?vue&type=script&lang=js"
export * from "./ServicesAndIncoterms.vue?vue&type=script&lang=js"
import style0 from "./ServicesAndIncoterms.vue?vue&type=style&index=0&id=ca1f77f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1f77f4",
  null
  
)

export default component.exports